import React from 'react';

export const
    SelectIcon = () => {
        return <svg className='icon--chevron icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 20'><path d='M19.863 17.625L17.505 20 0 2.375 2.358 0l17.505 17.625zM35 2.375L22.215 15.25l-2.357-2.373L32.641 0l2.358 2.375z'/></svg>;
    },
    SelectInvertIcon = () => {
        return <svg className='icon--chevroninverted icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 20'><path d='M15.137 2.375L17.495 0 35 17.625 32.642 20 15.137 2.375zM0 17.625L12.785 4.75l2.357 2.373L2.359 20 .001 17.625z'/></svg>;
    },
    SearchIcon = () => {
        return <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path d='M14.771 13.282l5.235 5.235-1.488 1.488-5.235-5.235a9.605 9.605 0 001.488-1.488zM7.368 0a7.368 7.368 0 110 14.737A7.368 7.368 0 017.367 0zm0 2.105a5.264 5.264 0 10.002 10.528 5.264 5.264 0 00-.002-10.528z'/></svg>;
    },
    CheckCircleUnchecked = () => {
        return <svg xmlns='http://www.w3.org/2000/svg' id='CheckCircleUnchecked' className='CheckCircleUnchecked' width='24' height='24' viewBox='0 0 24 24'>
            <circle cx='12' cy='12' r='11.5' fill='none' fillRule='evenodd' stroke='#c6c8c6' />
        </svg>;
    },
    CheckCircleChecked = () => {
        return <svg xmlns='http://www.w3.org/2000/svg' id='CheckCircleChecked' className='CheckCircleChecked' width='24' height='24' viewBox='0 0 24 24'>
            <g fill='none' fillRule='evenodd'>
                <circle cx='12' cy='12' r='11.5' fill='#6F94AA' stroke='#6F94AA' />
                <path stroke='#FFF' strokeWidth='2' d='M6 11.778l3.536 3.536 7.778-7.778' />
            </g>
        </svg>;
    };

export default {
    SelectIcon,
    SearchIcon,
    SelectInvertIcon,
    CheckCircleUnchecked,
    CheckCircleChecked
};
